/**
 * Replaces the default `OAuthRequestDialog` with {@link IronPhoenixOAuthRequestDialog}.
 *
 * `convertLegacyAppRoot` only keeps the `AppRouter` → `Root` subtree; siblings such as
 * `<IronPhoenixOAuthRequestDialog />` in `App.tsx` are dropped, so the stock dialog from
 * `@backstage/plugin-app` was still what users saw.
 */
import { createElement } from 'react';
import {
  AppRootElementBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { IronPhoenixOAuthRequestDialog } from './components/OAuthRequestDialog/IronPhoenixOAuthRequestDialog';

export const ironPhoenixOAuthDialogModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    AppRootElementBlueprint.make({
      name: 'oauth-request-dialog',
      params: {
        element: createElement(IronPhoenixOAuthRequestDialog),
      },
    }),
  ],
});
